import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LevelUp2Icon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M17.79,9H15v8H9V9H6.2a.49.49,0,0,1-.35-.84l5.8-5.8a.5.5,0,0,1,.71,0l5.79,5.78A.51.51,0,0,1,17.79,9Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M9,21h6a0,0,0,0,1,0,0v.5a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1-.5-.5V21A0,0,0,0,1,9,21Z"
  }), /*#__PURE__*/_jsx("rect", {
    x: "9",
    y: "17.97",
    width: "6",
    height: "2"
  })]
}), 'LevelUp2Icon');